import {KYCStatusBadgeComponent} from './kyc.status-badge.component';
import {KYCVerificationComponent} from './kyc.verification.component';
import {KYC_VERIFICATION_RESULTS_COMPONENTS} from './results';


export * from './kyc.verification.component';

export const KYC_VERIFICATION_COMPONENTS = [
    KYCVerificationComponent,
    KYCStatusBadgeComponent,
    KYC_VERIFICATION_RESULTS_COMPONENTS
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/kyc/index.ts